import React from "react";
import { withRouter } from "react-router-dom";
import Formanlist from "./components/Formanlist";
function Forman() {
  return (
    <>
      <Formanlist></Formanlist>
    </>
  );
}
export default withRouter(Forman);
